















































import { Component, Vue, Prop } from "vue-property-decorator";
import { users } from "../../api/users/users";
@Component({
  name: "ShiftFilters",
  props: {
    filters: {
      dateFrom: "",
      dateTo: ""
    }
  },
  model: {
    prop: "filters",
    event: "change"
  },
  watch: {
    date: function(val) {
      this.$props.filters.dateFrom = val;
    }
  }
})
export default class ShiftFilters extends Vue {
  public loading: boolean = false;
  public activeName: string = "1";
  public date: Date = new Date();
  public async mounted() {
    this.$props.filters.dateFrom = new Date(
      new Date().setDate(new Date().getDate() - 10)
    );
    this.date = new Date(new Date().setDate(new Date().getDate() - 10));
  }
  public update() {
    this.$forceUpdate();
  }
}
